import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { isTypingTarget } from '@/lib/keyboard';

// Ctrl+K / ⌘K, or "/", opens smart search — never while typing in an input, a textarea or anything contenteditable
// (so "/" in the Relay composer stays a "/"). The Media page keeps "/" for its own search box.
export default function useSmartShortcut(onOpen) {
  const { pathname } = useLocation();
  useEffect(() => {
    const onKey = (e) => {
      if (isTypingTarget(e.target)) return;
      const cmdK = (e.metaKey || e.ctrlKey) && !e.altKey && !e.shiftKey && e.key?.toLowerCase() === 'k';
      const slash = e.key === '/' && !e.metaKey && !e.ctrlKey && !e.altKey && !pathname.startsWith('/media');
      if (!cmdK && !slash) return;
      e.preventDefault();
      onOpen('');
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onOpen, pathname]);
}
